const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;

export interface UtmData {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

export const getUtmParams = (): UtmData => {
  const params = new URLSearchParams(window.location.search);
  const utm: UtmData = {};
  for (const key of UTM_PARAMS) {
    const val = params.get(key);
    if (val) utm[key] = val;
  }
  return utm;
};

export const sendFormEvent = (source: string) => {
  // GA4 / GTM
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'generate_lead', {
      event_category: 'form',
      event_label: source,
      value: 1,
    });
  }
  // dataLayer for GTM
  if (typeof window !== 'undefined' && (window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: 'form_submit',
      form_source: source,
    });
  }
  // Yandex Metrika
  if (typeof window !== 'undefined' && (window as any).ym) {
    (window as any).ym(105799887, 'reachGoal', 'form_submit', { form_source: source });
  }
};
